import { FormControlLabel, Switch as MuiSwitch, styled } from "@mui/material";

function Switch({ onChange, checked, label, color, ...props }) {
  return (
    <FormControlLabelStyle
      control={
        <MuiSwitch
          checked={checked}
          onChange={onChange}
          color={color || "primary"}
        />
      }
      {...props}
      label={label}
    />
  );
}

const FormControlLabelStyle = styled(FormControlLabel)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row-reverse",
  marginRight: " 0",
  width: "auto",
  marginLeft: theme.spacing(3),
  ".Mui-checked": {
    color: theme.palette.modules.checked,
  },
  ".Mui-checked+.MuiSwitch-track": {
    backgroundColor: theme.palette.modules.checked,
  },
  ".MuiTypography-root": {
    color: theme.palette.text.main,
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "16px",
  },

  [theme.breakpoints.down("sm")]: {
    justifyContent: "space-between",
    width: "100%",
    marginRight: theme.spacing(3),
  },
}));

export default Switch;
